import React from 'react'
 import QRCode from 'qrcode.react';

export default function QRCodeGenerator(props) {
    const { data } = props;
    return (
      <QRCode value={data}/>
    );
}
